import React from "react";
const SearchIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <rect
        fill="none"
        id="canvas_background"
        height="402"
        width="582"
        y="-1"
        x="-1"
      />
      <g>
        <path
          strokeWidth="0"
          stroke="null"
          id="svg_1"
          d="m16.110356,14.468402l-0.864762,0l-0.306498,-0.295552c1.072743,-1.247884 1.718578,-2.867945 1.718578,-4.630308c0,-3.929741 -3.185389,-7.11513 -7.11513,-7.11513s-7.11513,3.185389 -7.11513,7.11513s3.185389,7.11513 7.11513,7.11513c1.762363,0 3.382423,-0.645835 4.630308,-1.718578l0.295552,0.306498l0,0.864762l5.473177,5.46223l1.631007,-1.631007l-5.46223,-5.473177zm-6.567812,0c-2.725642,0 -4.925859,-2.200217 -4.925859,-4.925859s2.200217,-4.925859 4.925859,-4.925859s4.925859,2.200217 4.925859,4.925859s-2.200217,4.925859 -4.925859,4.925859z"
        />
        <path
          id="svg_2"
          d="m8.91781,6.0411l3.82192,4.64383l-3.82192,-4.64383z"
          fillOpacity="null"
          strokeOpacity="null"
          strokeWidth="0"
          stroke="null"
          fill="null"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/icons/SearchIcon.js